export const DATA_SOURCE_ADD_ROW = 'DATA_SOURCE_ADD_ROW';
export const DATA_SOURCE_DELETE_ROW = 'DATA_SOURCE_DELETE_ROW';
export const DATA_SOURCE_UPDATE_ROW = 'DATA_SOURCE_UPDATE_ROW';
export const DATA_SOURCE_IMPORT_ROWS = 'DATA_SOURCE_IMPORT_ROWS';
export const DATA_SOURCE_INITIAL_ROWS = 'DATA_SOURCE_INITIAL_ROWS';
export const DATA_SOURCE_SET_ROWS = 'DATA_SOURCE_SET_ROWS';
export const DATA_SOURCE_DELETE_ROW_ID = 'DATA_SOURCE_DELETE_ROW_ID';
export const DATA_SOURCE = 'DATA_SOURCE';
export const DATA_SOURCE_SET_QUERY = 'DATA_SOURCE_SET_QUERY';
export const DATA_SOURCE_LIST = 'DATA_SOURCE_LIST';
export const DATA_SOURCE_SET_STATUS = 'DATA_SOURCE_SET_STATUS';

export const addRow = (row) => ({
  type: DATA_SOURCE_ADD_ROW,
  payload: row,
});

export const deleteRow = (rowId) => ({
  type: DATA_SOURCE_DELETE_ROW,
  payload: rowId,
});

export const setDeleteRowId = (deleteRowId) => ({
  type: DATA_SOURCE_DELETE_ROW_ID,
  payload: deleteRowId,
});

export const setSource = (source) => ({
  type: DATA_SOURCE,
  payload: source,
});

export const updateRow = (rowId, key, value) => ({
  type: DATA_SOURCE_UPDATE_ROW,
  payload: { rowId, key, value },
});

export const importRows = (rows) => ({
  type: DATA_SOURCE_IMPORT_ROWS,
  payload: rows,
});

export const setInitialRows = (rows) => ({
  type: DATA_SOURCE_INITIAL_ROWS,
  payload: rows,
});

export const setRows = (rows) => ({
  type: DATA_SOURCE_SET_ROWS,
  payload: rows,
});

export const setQuery = (query) => ({
  type: DATA_SOURCE_SET_QUERY,
  payload: query,
});

export const setSourceDataList = (data) => ({
  type: DATA_SOURCE_LIST,
  payload: data,
});

export const setStatus = (payload) => ({
  type: DATA_SOURCE_SET_STATUS,
  payload,
});
